import {remCalc} from '_themeUtils'
import type {ThemeBreakpoints} from '_uiComponents'

const errorPage = {
    ErrorPage: {
        baseStyle: ({headerSize}: {headerSize: ThemeBreakpoints}) => ({
            container: {
                gap: 0,
                pt: {
                    base: `calc(${headerSize.base}px + 53px)`,
                    sm: `calc(${headerSize.sm}px + 53px)`,
                    md: `calc(${headerSize.md}px + 53px)`,
                    lg: `calc(${headerSize.lg}px + 53px)`,
                    xl: `calc(${headerSize.xl}px + 53px)`,
                    '2xl': `calc(${headerSize['2xl']}px + 53px)`,
                },
            },
            image: {
                width: '80%',
                maxW: remCalc(320),
                my: 'spacing.10',
            },
            errorHeader: {
                fontSize: remCalc(150),
                lineHeight: 1.2,
                fontWeight: '500',
                mb: 'spacing.2',
            },
            quote: {
                textStyle: 'paragraphSm',
                textAlign: 'center',
                letterSpacing: remCalc(0.6),
                pb: 'spacing.9',
            },
            message: {
                textStyle: 'displaySm',
                textAlign: 'center',
                letterSpacing: remCalc(0.6),
                pb: 'spacing.25',
                mb: 'spacing.4',
            },
        }),
    },
}

export default errorPage
